/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { AddToWatchlistResponse, AddToWatchlistVars } from '../openapi-types.gen.js';

export type { AddToWatchlistResponse, AddToWatchlistVars } from '../openapi-types.gen.js';

export const useAddToWatchlist = createMutationHook<AddToWatchlistVars, AddToWatchlistResponse, unknown>({
  specName: 'useAddToWatchlist',
  path: '/v1/watchlist/{kind}',
  method: 'POST',
  resolveUrl: (vars: AddToWatchlistVars) => `/v1/watchlist/${vars.kind}`,
  buildBody: (vars: AddToWatchlistVars) => ({ pubkey: vars.pubkey }),
  parseResponse: (raw: unknown): AddToWatchlistResponse => raw as AddToWatchlistResponse,
  optimistic: [{
    queryKey: ['watchlist', 'detail'],
    apply: (prev: any, vars: AddToWatchlistVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  viewerRelationship: {"kind":"watchlist","targetArg":"pubkey","active":true,"indexArg":"kind"} as const,
  
});
